import { render, staticRenderFns } from "./siteInfo.vue?vue&type=template&id=2b86bbc8"
import script from "./siteInfo.vue?vue&type=script&lang=js"
export * from "./siteInfo.vue?vue&type=script&lang=js"
import style0 from "./siteInfo.vue?vue&type=style&index=0&id=2b86bbc8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports